import {
  type SupportedLanguage,
  createTolgeeInstance,
  getStoredLanguage,
  storeLanguage,
} from '@/features/language-selection';
import { TolgeeProvider } from '@tolgee/react';
import { type ReactNode, useEffect, useRef, useState } from 'react';

export function TolgeeClientProvider({ children }: { children: ReactNode }) {
  const [isReady, setIsReady] = useState(false);
  const tolgeeRef = useRef<ReturnType<typeof createTolgeeInstance> | null>(null);

  if (!tolgeeRef.current) {
    tolgeeRef.current = createTolgeeInstance();
  }

  useEffect(() => {
    // biome-ignore lint/style/noNonNullAssertion: tolgeeRef is always initialized before this effect
    const tolgee = tolgeeRef.current!;
    const lang = getStoredLanguage();
    storeLanguage(lang);

    const unsubscribe = tolgee.on('language', (lang) => {
      storeLanguage(lang.value as SupportedLanguage);
    });

    tolgee
      .run()
      .then(() => {
        setIsReady(true);
      })
      .catch((error) => {
        console.error('Tolgee initialization failed:', error);
        setIsReady(true);
      });

    return () => {
      unsubscribe.unsubscribe();
    };
  }, []);

  if (!isReady) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="text-muted-foreground">Chargement...</div>
      </div>
    );
  }

  return <TolgeeProvider tolgee={tolgeeRef.current}>{children}</TolgeeProvider>;
}
